const BASE_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://api.spraotechnologies.com/api'
    : 'http://localhost:5000/api';

export const API_BASE_URL = BASE_URL;